(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bo-b2b-eme"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bo-wholesale')) {
    class BoWholesale extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected || this.controller) return;
        this.controller = new AbortController();
        this.signal = this.controller.signal;
        this.media = matchMedia('(max-width: 989px)');
        this.dialog = this.querySelector('[data-bo-dialog]');
        this.panel = this.querySelector('[data-bo-panel]');
        this.triggers = Array.from(this.querySelectorAll('[data-bo-b2b-open]'));
        this.closeButton = this.querySelector('[data-bo-b2b-close]');
        this.form = this.querySelector('.bo-wholesale__form');
        this.updateHeader();
        window.addEventListener('resize', () => this.scheduleHeader(), { passive: true, signal: this.signal });
        window.addEventListener('load', () => this.scheduleHeader(), { once: true, signal: this.signal });
        this.media.addEventListener('change', () => this.scheduleHeader(), { signal: this.signal });
        if (document.fonts) document.fonts.ready.then(() => { if (this.isConnected) this.scheduleHeader(); });

        if (!this.dialog || !this.panel || typeof this.dialog.showModal !== 'function') return;
        this.dialog.append(this.panel);
        this.setAttribute('data-enhanced', '');
        this.closeButton.hidden = false;
        this.triggers.forEach(trigger => {
          trigger.setAttribute('aria-haspopup', 'dialog');
          trigger.setAttribute('aria-controls', this.dialog.id);
          trigger.setAttribute('aria-expanded', 'false');
          trigger.addEventListener('click', event => {
            event.preventDefault();
            this.open(trigger);
          }, { signal: this.signal });
        });
        this.closeButton.addEventListener('click', () => this.dismiss(), { signal: this.signal });
        this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.dismiss(); }, { signal: this.signal });
        this.dialog.addEventListener('close', () => { if (!this.dialog.open) this.release(); }, { signal: this.signal });
        this.dialog.addEventListener('pointerdown', event => { this.outsidePointer = event.target === this.dialog; }, { signal: this.signal });
        this.dialog.addEventListener('click', event => {
          if (this.outsidePointer && event.target === this.dialog) this.dismiss();
          this.outsidePointer = false;
        }, { signal: this.signal });
        this.dialog.addEventListener('keydown', event => this.trapFocus(event), { signal: this.signal });
        this.form?.addEventListener('submit', event => this.onSubmit(event), { signal: this.signal });
        window.addEventListener('pageshow', () => this.resetSubmit(), { signal: this.signal });

        const pause = this.querySelector('[data-bo-pause]');
        if (pause) {
          pause.hidden = false;
          pause.addEventListener('click', () => {
            const paused = pause.getAttribute('aria-pressed') !== 'true';
            pause.setAttribute('aria-pressed', String(paused));
            pause.closest('.bo-wholesale__ticker').classList.toggle('bo-wholesale__ticker--paused', paused);
          }, { signal: this.signal });
        }
        this.reopenResponse();
      }

      scheduleHeader() {
        cancelAnimationFrame(this.headerFrame);
        this.headerFrame = requestAnimationFrame(() => this.updateHeader());
      }

      findHeader() {
        const selectors = ['[data-eme-header]', '.shopify-section-header', 'sticky-header', '.header-wrapper', 'header[role="banner"]', '.shopify-section-group-header-group'];
        for (const selector of selectors) {
          const matches = document.querySelectorAll(selector);
          for (const candidate of matches) {
            if (!this.contains(candidate) && candidate.getBoundingClientRect().height > 0) return candidate;
          }
        }
        return null;
      }

      updateHeader() {
        if (!this.isConnected || this.scrollLock) return;
        if (this.dataset.reserveHeader !== 'true') {
          this.style.setProperty('--bo-header-safe', '0px');
          return;
        }
        const number = (value, fallback) => Number.isFinite(Number(value)) ? Number(value) : fallback;
        const mobile = this.media.matches;
        const fallback = number(mobile ? this.dataset.headerMobile : this.dataset.headerDesktop, mobile ? 105 : 140);
        const gap = number(mobile ? this.dataset.headerGapMobile : this.dataset.headerGapDesktop, mobile ? 10 : 16);
        const header = this.findHeader();
        let safe = fallback + gap;
        if (header) {
          let floating = null;
          let node = header;
          while (node && node !== document.body) {
            if (getComputedStyle(node).position === 'fixed') { floating = node; break; }
            node = node.parentElement;
          }
          if (!floating) {
            const inner = header.querySelector('[data-eme-header], sticky-header, .header-wrapper');
            if (inner && getComputedStyle(inner).position === 'fixed') floating = inner;
          }
          if (floating) {
            const rect = floating.getBoundingClientRect();
            const cssTop = parseFloat(getComputedStyle(floating).top);
            const bottom = rect.top >= 0 ? rect.bottom : (Number.isFinite(cssTop) ? cssTop : 0) + rect.height;
            const start = this.getBoundingClientRect().top + window.scrollY;
            const overlap = Math.max(0, bottom - start);
            safe = overlap > 0 ? Math.ceil(overlap + gap) : 0;
          } else {
            safe = 0;
          }
          if (this.observedHeader !== header) {
            this.resizeObserver?.disconnect();
            this.mutationObserver?.disconnect();
            this.observedHeader = header;
            if ('ResizeObserver' in window) {
              this.resizeObserver = new ResizeObserver(() => this.scheduleHeader());
              this.resizeObserver.observe(header);
              if (floating && floating !== header) this.resizeObserver.observe(floating);
            }
            this.mutationObserver = new MutationObserver(() => this.scheduleHeader());
            this.mutationObserver.observe(header, { attributes: true, attributeFilter: ['class', 'style'] });
            if (header.parentElement) this.mutationObserver.observe(header.parentElement, { attributes: true, attributeFilter: ['class', 'style'] });
          }
        }
        const next = `${safe}px`;
        if (this.style.getPropertyValue('--bo-header-safe') !== next) this.style.setProperty('--bo-header-safe', next);
      }

      open(trigger) {
        if (this.dialog.open) return;
        if (BoWholesale.active && BoWholesale.active !== this) BoWholesale.active.dismiss();
        this.previousFocus = trigger || (document.activeElement instanceof HTMLElement ? document.activeElement : null);
        this.dialog.showModal();
        BoWholesale.active = this;
        this.triggers.forEach(item => item.setAttribute('aria-expanded', 'true'));
        this.lockScroll();
        const response = this.panel.querySelector('[data-bo-b2b-response]');
        (response || this.closeButton).focus({ preventScroll: true });
      }

      lockScroll() {
        if (this.scrollLock) return;
        const body = document.body;
        const properties = ['position', 'top', 'left', 'width', 'overflow', 'padding-right', 'box-sizing'];
        this.scrollLock = {
          x: window.scrollX, y: window.scrollY,
          body: properties.map(name => [name, body.style.getPropertyValue(name), body.style.getPropertyPriority(name)]),
          rootOverflow: [document.documentElement.style.getPropertyValue('overflow'), document.documentElement.style.getPropertyPriority('overflow')]
        };
        const scrollbar = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
        const padding = parseFloat(getComputedStyle(body).paddingRight) || 0;
        document.documentElement.style.setProperty('overflow', 'hidden');
        body.style.setProperty('position', 'fixed');
        body.style.setProperty('top', `${-this.scrollLock.y}px`);
        body.style.setProperty('left', `${-this.scrollLock.x}px`);
        body.style.setProperty('width', '100%');
        body.style.setProperty('box-sizing', 'border-box');
        body.style.setProperty('overflow', 'hidden');
        if (scrollbar) body.style.setProperty('padding-right', `${padding + scrollbar}px`);
      }

      dismiss() {
        if (this.dialog?.open) this.dialog.close();
        this.release();
      }

      release() {
        this.triggers?.forEach(item => item.setAttribute('aria-expanded', 'false'));
        if (BoWholesale.active === this) BoWholesale.active = null;
        if (this.scrollLock) {
          const state = this.scrollLock;
          this.scrollLock = null;
          state.body.forEach(([name, value, priority]) => {
            if (value) document.body.style.setProperty(name, value, priority);
            else document.body.style.removeProperty(name);
          });
          const [value, priority] = state.rootOverflow;
          if (value) document.documentElement.style.setProperty('overflow', value, priority);
          else document.documentElement.style.removeProperty('overflow');
          window.scrollTo({ left: state.x, top: state.y, behavior: 'instant' });
        }
        if (this.previousFocus?.isConnected && this.isConnected) this.previousFocus.focus({ preventScroll: true });
        this.previousFocus = null;
        if (this.isConnected) this.scheduleHeader();
      }

      trapFocus(event) {
        if (event.key !== 'Tab') return;
        const elements = Array.from(this.panel.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(element => !element.hidden && element.getClientRects().length > 0);
        const first = elements[0];
        const last = elements[elements.length - 1];
        if (!first) { event.preventDefault(); return; }
        if (event.shiftKey && (document.activeElement === first || !elements.includes(document.activeElement))) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && (document.activeElement === last || !elements.includes(document.activeElement))) {
          event.preventDefault(); first.focus();
        }
      }

      onSubmit(event) {
        if (event.defaultPrevented) return;
        try { sessionStorage.setItem('bo-wholesale-pending', JSON.stringify({ id: this.dataset.sectionId, time: Date.now() })); } catch (_) {}
        const button = this.form.querySelector('[type="submit"]');
        if (button) button.setAttribute('aria-busy', 'true');
        clearTimeout(this.submitTimer);
        this.submitTimer = setTimeout(() => this.resetSubmit(), 15000);
      }

      resetSubmit() {
        clearTimeout(this.submitTimer);
        this.form?.querySelector('[type="submit"]')?.removeAttribute('aria-busy');
      }

      reopenResponse() {
        const response = this.panel.querySelector('[data-bo-b2b-response]');
        if (!response) return;
        let pending = null;
        try { pending = JSON.parse(sessionStorage.getItem('bo-wholesale-pending')); } catch (_) {}
        const ownHash = location.hash === `#${this.form.id}`;
        const ownPending = pending && pending.id === this.dataset.sectionId && Date.now() - pending.time < 1800000;
        const onlyForm = document.querySelectorAll('bo-wholesale').length === 1 && location.search.includes('contact_posted=');
        if (ownHash || ownPending || onlyForm) {
          this.open();
          if (ownPending) { try { sessionStorage.removeItem('bo-wholesale-pending'); } catch (_) {} }
        }
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.headerFrame);
        clearTimeout(this.submitTimer);
        this.dismiss();
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        this.mutationObserver?.disconnect();
        this.observedHeader = null;
      }
    }
    customElements.define('bo-wholesale', BoWholesale);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bo-categorias"] && !Shopify.designMode) return;
  try {
    
  class EmeCategories extends HTMLElement {
    connectedCallback() {
      if (this.emeAbortController) return;

      const viewport = this.querySelector(
        '[data-eme-categories-viewport]'
      );

      if (!viewport) return;

      const prevButton = this.querySelector(
        '[data-eme-categories-prev]'
      );

      const nextButton = this.querySelector(
        '[data-eme-categories-next]'
      );

      const cards = Array.from(
        this.querySelectorAll('.eme-categories__card')
      );

      const controller = new AbortController();
      const { signal } = controller;

      this.emeAbortController = controller;

      let isDragging = false;
      let didDrag = false;
      let isCaptured = false;
      let pointerId = null;
      let startX = 0;
      let startScrollLeft = 0;
      let blockClickUntil = 0;

      this.emeScrollFrame = null;

      const dragThreshold = 5;

      const reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      );

      const getStep = () => {
        const firstCard = cards[0];

        return (
          firstCard?.getBoundingClientRect().width ||
          viewport.clientWidth * 0.8
        );
      };

      const updateControls = () => {
        const maxScroll = Math.max(
          0,
          viewport.scrollWidth - viewport.clientWidth
        );

        const hasOverflow = maxScroll > 2;

        this.classList.toggle(
          'has-overflow',
          hasOverflow
        );

        if (!hasOverflow) {
          if (prevButton) {
            prevButton.disabled = true;
          }

          if (nextButton) {
            nextButton.disabled = true;
          }

          return;
        }

        const tolerance = 3;

        if (prevButton) {
          prevButton.disabled =
            viewport.scrollLeft <= tolerance;
        }

        if (nextButton) {
          nextButton.disabled =
            viewport.scrollLeft >= maxScroll - tolerance;
        }
      };

      const queueControlsUpdate = () => {
        if (this.emeScrollFrame !== null) return;

        this.emeScrollFrame =
          window.requestAnimationFrame(() => {
            this.emeScrollFrame = null;
            updateControls();
          });
      };

      const snapToClosestCard = () => {
        if (!didDrag || cards.length === 0) return;

        const currentScroll = viewport.scrollLeft;

        let closestCard = cards[0];

        let closestDistance = Math.abs(
          cards[0].offsetLeft - currentScroll
        );

        for (
          let index = 1;
          index < cards.length;
          index += 1
        ) {
          const distance = Math.abs(
            cards[index].offsetLeft - currentScroll
          );

          if (distance < closestDistance) {
            closestCard = cards[index];
            closestDistance = distance;
          }
        }

        viewport.scrollTo({
          left: closestCard.offsetLeft,
          behavior: reducedMotion.matches
            ? 'auto'
            : 'smooth'
        });
      };

      const endDrag = () => {
        if (!isDragging) return;

        isDragging = false;

        this.classList.remove('is-dragging');

        if (
          isCaptured &&
          pointerId !== null &&
          viewport.hasPointerCapture?.(pointerId)
        ) {
          viewport.releasePointerCapture(pointerId);
        }

        if (didDrag) {
          blockClickUntil =
            performance.now() + 300;

          snapToClosestCard();
        }

        pointerId = null;
        isCaptured = false;

        window.setTimeout(() => {
          didDrag = false;
        }, 0);
      };

      const scrollByStep = (direction) => {
        viewport.scrollBy({
          left: getStep() * direction,
          behavior: reducedMotion.matches
            ? 'auto'
            : 'smooth'
        });
      };

      viewport.addEventListener(
        'pointerdown',
        (event) => {
          if (event.pointerType !== 'mouse') {
            return;
          }

          if (
            event.button !== 0 ||
            !event.isPrimary
          ) {
            return;
          }

          if (
            viewport.scrollWidth <=
            viewport.clientWidth + 2
          ) {
            return;
          }

          isDragging = true;
          didDrag = false;
          isCaptured = false;
          pointerId = event.pointerId;
          startX = event.clientX;
          startScrollLeft = viewport.scrollLeft;
        },
        { signal }
      );

      viewport.addEventListener(
        'pointermove',
        (event) => {
          if (
            !isDragging ||
            event.pointerType !== 'mouse'
          ) {
            return;
          }

          if ((event.buttons & 1) !== 1) {
            endDrag();
            return;
          }

          const moveX =
            event.clientX - startX;

          if (
            !didDrag &&
            Math.abs(moveX) <= dragThreshold
          ) {
            return;
          }

          if (!isCaptured) {
            isCaptured = true;

            viewport.setPointerCapture?.(
              pointerId
            );

            this.classList.add(
              'is-dragging'
            );
          }

          didDrag = true;

          viewport.scrollLeft =
            startScrollLeft - moveX;

          event.preventDefault();
        },
        {
          signal,
          passive: false
        }
      );

      viewport.addEventListener(
        'pointerup',
        endDrag,
        { signal }
      );

      viewport.addEventListener(
        'pointercancel',
        endDrag,
        { signal }
      );

      viewport.addEventListener(
        'lostpointercapture',
        endDrag,
        { signal }
      );

      viewport.addEventListener(
        'scroll',
        queueControlsUpdate,
        {
          signal,
          passive: true
        }
      );

      window.addEventListener(
        'pointerup',
        (event) => {
          if (
            event.pointerType === 'mouse' &&
            event.pointerId === pointerId
          ) {
            endDrag();
          }
        },
        { signal }
      );

      viewport.addEventListener(
        'click',
        (event) => {
          if (
            performance.now() >=
            blockClickUntil
          ) {
            return;
          }

          event.preventDefault();
          event.stopPropagation();
        },
        {
          signal,
          capture: true
        }
      );

      viewport.addEventListener(
        'dragstart',
        (event) => {
          event.preventDefault();
        },
        { signal }
      );

      viewport.addEventListener(
        'keydown',
        (event) => {
          if (event.key === 'ArrowRight') {
            scrollByStep(1);
            event.preventDefault();
          } else if (
            event.key === 'ArrowLeft'
          ) {
            scrollByStep(-1);
            event.preventDefault();
          } else if (
            event.key === 'Home'
          ) {
            viewport.scrollTo({
              left: 0,
              behavior: reducedMotion.matches
                ? 'auto'
                : 'smooth'
            });

            event.preventDefault();
          } else if (
            event.key === 'End'
          ) {
            viewport.scrollTo({
              left: viewport.scrollWidth,
              behavior: reducedMotion.matches
                ? 'auto'
                : 'smooth'
            });

            event.preventDefault();
          }
        },
        { signal }
      );

      prevButton?.addEventListener(
        'click',
        () => {
          scrollByStep(-1);
        },
        { signal }
      );

      nextButton?.addEventListener(
        'click',
        () => {
          scrollByStep(1);
        },
        { signal }
      );

      window.addEventListener(
        'blur',
        endDrag,
        { signal }
      );

      if ('ResizeObserver' in window) {
        this.emeResizeObserver =
          new ResizeObserver(updateControls);

        this.emeResizeObserver.observe(
          viewport
        );

        const track = this.querySelector(
          '.eme-categories__track'
        );

        if (track) {
          this.emeResizeObserver.observe(
            track
          );
        }
      } else {
        window.addEventListener(
          'resize',
          updateControls,
          {
            signal,
            passive: true
          }
        );
      }

      updateControls();
    }

    disconnectedCallback() {
      this.emeAbortController?.abort();

      this.emeAbortController = null;

      this.emeResizeObserver?.disconnect();

      this.emeResizeObserver = null;

      if (
        this.emeScrollFrame !== null &&
        this.emeScrollFrame !== undefined
      ) {
        window.cancelAnimationFrame(
          this.emeScrollFrame
        );
      }

      this.emeScrollFrame = null;

      this.classList.remove(
        'is-dragging',
        'has-overflow'
      );
    }
  }

  if (
    'customElements' in window &&
    !customElements.get('eme-categories')
  ) {
    customElements.define(
      'eme-categories',
      EmeCategories
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eme-recomendados"] && !Shopify.designMode) return;
  try {
    

  (() => {

    if (window.__emeRecommendedHorizonV3) { window.__emeRecommendedHorizonV3.initAll(); return; }

    const instances = new WeakMap();

    const wishlistKey = 'eme_wishlist_v1';

    const legacyWishlistKey = 'eme-recommended-wishlist';

    let wishlistMemory = [];

    let cartBusy = false;

    let eventModulePromise;

    const ajaxUrl = value => {

      const url = new URL(value || '/cart', location.origin);

      if (!url.pathname.endsWith('.js')) url.pathname += '.js';

      return url.href;

    };

    const cartSectionIds = () => [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el => el.dataset.sectionId).filter(Boolean))].slice(0,5);

    const readWishlist = () => {

      try {

        const items = JSON.parse(localStorage.getItem(wishlistKey) || '[]');

        if (Array.isArray(items)) wishlistMemory = [...new Map(items.filter(item => item && item.handle).map(item => [item.handle,item])).values()];

      } catch (error) {}

      return wishlistMemory.slice();

    };

    const saveWishlist = items => {

      wishlistMemory = items;

      try {

        localStorage.setItem(wishlistKey,JSON.stringify(items));

        localStorage.setItem(legacyWishlistKey,JSON.stringify(items.map(item => item.handle)));

      } catch (error) { return false; }

      document.dispatchEvent(new CustomEvent('eme:wishlist:updated',{detail:{items}}));

      window.dispatchEvent(new CustomEvent('eme:wishlist:change'));

      return true;

    };

    function migrateWishlist() {

      try {

        if (localStorage.getItem('eme_recommended_migrated_v2')) return;

        const legacy = JSON.parse(localStorage.getItem(legacyWishlistKey) || '[]');

        const items = readWishlist();

        if (Array.isArray(legacy)) legacy.filter(handle => typeof handle === 'string').forEach(handle => { if (!items.some(item => item.handle === handle)) items.push({handle}); });

        if (!legacy.length || saveWishlist(items)) localStorage.setItem('eme_recommended_migrated_v2','true');

      } catch (error) {}

    }

    const loadEventModule = section => {

      if (!eventModulePromise) {

        eventModulePromise = import('@shopify/events')

          .catch(() => import(section.dataset.eventsUrl))

          .catch(() => null);

      }

      return eventModulePromise;

    };

    async function refreshCartFallback(sections) {

      const ids = cartSectionIds();

      if (!ids.length) return;

      try {

        if (!sections || ids.some(id => !sections[id])) {

          const url = new URL(location.href);

          url.searchParams.set('sections',ids.join(','));

          const response = await fetch(url.href,{headers:{Accept:'application/json'},credentials:'same-origin'});

          if (!response.ok) return;

          sections = await response.json();

        }

        ids.forEach(id => {

          if (!sections[id]) return;

          const parsed = new DOMParser().parseFromString(sections[id],'text/html');

          const currentDrawer = document.querySelector('theme-drawer#cart-drawer,cart-drawer-component');

          const replacementDrawer = parsed.querySelector('.cart-drawer__inner');

          const currentInner = currentDrawer?.querySelector('.cart-drawer__inner');

          if (currentInner && replacementDrawer) { currentInner.replaceWith(replacementDrawer); return; }

          const current = [...document.querySelectorAll('cart-items-component')].find(el => el.dataset.sectionId === id);

          const replacement = [...parsed.querySelectorAll('cart-items-component')].find(el => el.dataset.sectionId === id);

          if (current && replacement) current.replaceWith(replacement);

        });

      } catch (error) {}

    }

    async function notifyCart(section,cart,result,variantId,startedEventModule) {

      try {

        const module = await Promise.race([
          startedEventModule || loadEventModule(section),
          new Promise(resolve => setTimeout(() => resolve(null), 1000))
        ]);

        const emit = event => {

          const drawers = section.dataset.openCartAfterAdd === 'false' ? [...document.querySelectorAll('cart-drawer-component[auto-open]')] : [];

          drawers.forEach(drawer => drawer.removeAttribute('auto-open'));

          try { section.dispatchEvent(event); }

          finally { drawers.forEach(drawer => drawer.setAttribute('auto-open','')); }

        };

        if (cart && module?.CartLinesUpdateEvent) {

          const EventClass = module.CartLinesUpdateEvent;

          emit(new EventClass({action:'add',context:'product',lines:[{merchandiseId:String(variantId),quantity:1}],promise:Promise.resolve({cart:EventClass.createCartFromAjaxResponse(cart),detail:{items:cart.items,itemCount:cart.item_count,source:'product-form-component',sourceId:section.id,sections:result.sections,didError:false}})}));

          await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));

          return true;

        }

        if (cart && module?.CartAddEvent) {

          emit(new module.CartAddEvent(cart,String(variantId),{source:'product-form-component',itemCount:cart.item_count,sections:result.sections}));

          return true;

        }

      } catch (error) {}

      return false;

    }

    async function openCart(section) {

      if (section.dataset.openCartAfterAdd === 'false') return;

      const actions = window.Shopify?.actions;

      if (actions?.openCart && !actions.openCart.isDefault?.()) { try { await actions.openCart(); return; } catch (error) {} }

      const drawer = document.querySelector('theme-drawer#cart-drawer');

      if (drawer) {

        if (!customElements.get('theme-drawer')) await Promise.race([customElements.whenDefined('theme-drawer'),new Promise(resolve => setTimeout(resolve,1500))]);

        if (drawer.isOpen || drawer.hasAttribute('open')) return;

        if (typeof drawer.open === 'function') { try { await drawer.open(); return; } catch (error) {} }

      }

      const oldDrawer = document.querySelector('cart-drawer-component');

      if (oldDrawer?.isOpen || oldDrawer?.querySelector('dialog[open]')) return;

      if (typeof oldDrawer?.showDialog === 'function') { try { oldDrawer.showDialog(); return; } catch (error) {} }

      if (typeof oldDrawer?.open === 'function') { try { oldDrawer.open(); return; } catch (error) {} }

      const trigger = document.querySelector('[aria-controls="cart-drawer"][data-testid="cart-drawer-trigger"],[aria-controls="cart-drawer"]');

      if (trigger) { trigger.click(); return; }

      location.assign(section.dataset.cartUrl || '/cart');

    }

    function init(section) {

      if (instances.has(section)) return;

      const controller = new AbortController();

      const {signal} = controller;

      const dialog = section.querySelector('[data-eme-size-sheet]');

      const optionsContainer = section.querySelector('[data-eme-sheet-options]');

      let opener;

      let previousOverflow;

      let previousPadding;

      let observer;

      let loading = false;

      let disposed = false;

      const status = section.querySelector('[data-eme-status]');

      const sheetStatus = section.querySelector('[data-eme-sheet-status]');

      const setStatus = (message,isError = false) => {

        status.textContent = message;

        status.classList.toggle('is-error',isError);

        if (dialog.open) sheetStatus.textContent = message;

      };

      const syncWishlist = () => {

        const handles = new Set(readWishlist().map(item => item.handle));

        section.querySelectorAll('[data-eme-wishlist]').forEach(button => {

          const saved = handles.has(button.dataset.productHandle);

          button.classList.toggle('is-saved',saved);

          button.setAttribute('aria-pressed',String(saved));

          button.setAttribute('aria-label',(saved ? 'Quitar ' : 'Guardar ') + button.dataset.productTitle);

        });

      };

      const unlockBody = () => {

        if (previousOverflow === undefined) return;

        document.body.style.overflow = previousOverflow;

        document.body.style.paddingRight = previousPadding;

        previousOverflow = undefined;

      };

      const closeSheet = (restoreFocus = true) => {

        if (!dialog.open) return;

        dialog.close();

        unlockBody();

        opener?.setAttribute('aria-expanded','false');

        if (restoreFocus && opener?.isConnected) opener.focus({preventScroll:true});

      };

      function openSheet(button) {

        const template = button.closest('[data-eme-card]')?.querySelector('[data-eme-size-options]');

        if (!template) return;

        document.dispatchEvent(new CustomEvent('eme:mobile-sheet:opening',{detail:{sheet:dialog}}));

        opener = button;

        optionsContainer.replaceChildren(template.content.cloneNode(true));

        sheetStatus.textContent = '';

        dialog.setAttribute('aria-label','Elegir opciones para ' + button.closest('[data-eme-card]').querySelector('.eme-recommended__product-title').textContent.trim());

        previousOverflow = document.body.style.overflow;

        previousPadding = document.body.style.paddingRight;

        const scrollbarWidth = innerWidth - document.documentElement.clientWidth;

        if (scrollbarWidth > 0) document.body.style.paddingRight = (parseFloat(getComputedStyle(document.body).paddingRight) + scrollbarWidth) + 'px';

        document.body.style.overflow = 'hidden';

        dialog.showModal();

        button.setAttribute('aria-expanded','true');

        (optionsContainer.querySelector('button:not(:disabled)') || dialog).focus({preventScroll:true});

      }

      async function addToCart(button) {

        const variantId = button.dataset.variantId;

        if (cartBusy || button.disabled || !/^\d+$/.test(variantId || '')) return;

        cartBusy = true;

        const addButtons = [...section.querySelectorAll('[data-eme-add]')];

        const originalStates = addButtons.map(el => [el,el.disabled]);

        originalStates.forEach(([el]) => { el.disabled = true; });

        button.setAttribute('aria-busy','true');

        const label = button.querySelector('[data-add-label]');

        const originalLabel = label?.textContent;

        let accepted = false;

        if (label) label.textContent = '…';

        setStatus('');

        const startedEventModule = loadEventModule(section);

        try {

          const payload = {items:[{id:Number(variantId),quantity:1}],sections_url:location.pathname};

          const ids = cartSectionIds();

          if (ids.length) payload.sections = ids;

          const response = await fetch(ajaxUrl(section.dataset.cartAddUrl),{method:'POST',headers:{Accept:'application/json','Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},credentials:'same-origin',body:JSON.stringify(payload)});

          const result = await response.json().catch(() => ({}));

          if (!response.ok || result.status) throw new Error(result.description || result.message || 'No se pudo añadir el producto.');

          accepted = true;

          if (label) label.textContent = '✓';

          setStatus('Producto añadido al carrito.');

          const cartResponse = await fetch(ajaxUrl(section.dataset.cartUrl),{headers:{Accept:'application/json'},credentials:'same-origin'}).catch(() => null);

          const cart = cartResponse?.ok ? await cartResponse.json().catch(() => null) : null;

          closeSheet(false);

          const notified = await notifyCart(section,cart,result,variantId,startedEventModule);

          if (!notified) await refreshCartFallback(result.sections);

          if (cart) {

            document.querySelectorAll('cart-icon').forEach(icon => { if (typeof icon.renderCartBubble === 'function') icon.renderCartBubble(cart.item_count); });

            document.querySelectorAll('[data-cart-count],[data-eme-cart-count]').forEach(el => { el.textContent = cart.item_count; });

          }

          await openCart(section);

        } catch (error) {

          if (!accepted) {

            if (label) label.textContent = originalLabel;

            setStatus(error.message || 'No se pudo añadir el producto.',true);

          }

        } finally {

          cartBusy = false;

          originalStates.forEach(([el,disabled]) => { if (!accepted || el !== button) el.disabled = disabled; });

          const restoreButton = () => {

            button.removeAttribute('aria-busy');

            button.disabled = originalStates.find(([el]) => el === button)?.[1] || false;

            if (label?.isConnected) label.textContent = originalLabel;

          };

          if (accepted) setTimeout(restoreButton,850);

          else restoreButton();

        }

      }

      section.addEventListener('click',event => {

        const button = event.target.closest('[data-eme-add],[data-eme-mobile-open],[data-eme-mobile-close],[data-eme-wishlist]');

        if (!button || !section.contains(button)) return;

        event.preventDefault();

        if (button.matches('[data-eme-add]')) { addToCart(button); return; }

        if (button.matches('[data-eme-mobile-open]')) { openSheet(button); return; }

        if (button.matches('[data-eme-mobile-close]')) { closeSheet(); return; }

        const items = readWishlist();

        const handle = button.dataset.productHandle;

        const index = items.findIndex(item => item.handle === handle);

        if (index >= 0) items.splice(index,1);

        else items.push({handle,title:button.dataset.productTitle,url:button.dataset.productUrl,image:button.dataset.productImage || '',price:button.dataset.productPrice});

        if (saveWishlist(items)) setStatus(index >= 0 ? 'Producto eliminado de guardados.' : 'Producto guardado.');

        else setStatus('No se pudo guardar el producto en este navegador.',true);

        syncWishlist();

      },{signal});

      dialog.addEventListener('click',event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientY < r.top || event.clientY > r.bottom || event.clientX < r.left || event.clientX > r.right) closeSheet(); } },{signal});

      dialog.addEventListener('cancel',event => { event.preventDefault(); closeSheet(); },{signal});

      dialog.addEventListener('keydown',event => {

        if (event.key !== 'Tab') return;

        const buttons = [...dialog.querySelectorAll('button:not(:disabled)')];

        const first = buttons[0],last = buttons[buttons.length - 1];

        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }

        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }

      },{signal});

      dialog.addEventListener('close',() => { unlockBody(); opener?.setAttribute('aria-expanded','false'); },{signal});

      document.addEventListener('eme:mobile-sheet:opening',event => { if (event.detail?.sheet !== dialog) closeSheet(false); },{signal});

      document.addEventListener('eme:wishlist:updated',syncWishlist,{signal});

      window.addEventListener('eme:wishlist:change',syncWishlist,{signal});

      window.addEventListener('storage',event => { if (event.key === wishlistKey || event.key === null) syncWishlist(); },{signal});

      window.addEventListener('resize',() => { if (innerWidth >= 1025) closeSheet(); },{signal});

      async function loadRecommendations() {

        if (loading || disposed || section.dataset.recommendationsPending !== 'true') return;

        loading = true;

        observer?.disconnect();

        const requestController = new AbortController();

        const abortRequest = () => requestController.abort();

        signal.addEventListener('abort', abortRequest, {once: true});

        const requestTimeout = setTimeout(abortRequest, 8000);

        const finishEmptyState = () => {

          const empty = section.querySelector('[data-eme-empty]');

          if (empty && !disposed) {

            empty.textContent = section.dataset.designMode === 'true'

              ? 'Selecciona una colección con productos en los ajustes de esta sección.'

              : 'No hay productos disponibles para mostrar en este momento.';

          }

        };

        try {

          if (!section.dataset.productId || !section.dataset.recommendationsUrl) {

            finishEmptyState();

            return;

          }

          const url = new URL(section.dataset.recommendationsUrl, location.origin);

          url.searchParams.set('section_id', section.dataset.sectionId);

          url.searchParams.set('product_id', section.dataset.productId);

          url.searchParams.set('limit', section.dataset.limit);

          url.searchParams.set('intent', 'related');

          const response = await fetch(url.href, {

            headers: {Accept: 'text/html'},

            credentials: 'same-origin',

            signal: requestController.signal

          });

          if (!response.ok) throw new Error('No se pudieron cargar las recomendaciones.');

          const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');

          const replacement = parsed.getElementById(section.id)?.querySelector('[data-eme-content]');

          if (disposed) return;

          // Preserve the server-rendered collection if the response is empty or invalid.

          if (!replacement?.querySelector('[data-eme-card]')) {

            finishEmptyState();

            return;

          }

          const apply = () => {

            if (disposed) return;

            section.querySelector('[data-eme-content]').replaceChildren(...replacement.childNodes);

            section.hidden = false;

            syncWishlist();

          };

          if (dialog.open) dialog.addEventListener('close', apply, {once: true, signal});

          else apply();

        } catch (error) {

          finishEmptyState();

        } finally {

          clearTimeout(requestTimeout);

          signal.removeEventListener('abort', abortRequest);

          section.dataset.recommendationsPending = 'false';

          section.removeAttribute('data-loading');

          section.removeAttribute('aria-busy');

        }

      }

      instances.set(section,{destroy() { disposed = true; closeSheet(false); observer?.disconnect(); controller.abort(); instances.delete(section); }});

      migrateWishlist();

      syncWishlist();

      if (section.dataset.recommendationsPending === 'true') {

        if ('IntersectionObserver' in window) { observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) loadRecommendations(); },{rootMargin:'200px 0px'}); observer.observe(section); }

        else loadRecommendations();

      }

    }

    function initAll() { document.querySelectorAll('[data-eme-recommended]').forEach(init); }

    window.__emeRecommendedHorizonV3 = {initAll};

    document.addEventListener('shopify:section:load',initAll);

    document.addEventListener('shopify:section:unload',event => { const sections = event.target.matches?.('[data-eme-recommended]') ? [event.target] : [...event.target.querySelectorAll('[data-eme-recommended]')]; sections.forEach(section => instances.get(section)?.destroy()); });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initAll,{once:true});

    else initAll();

  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
